<template>
  <div>
    <div v-if="canPickColor" class="flex items-center py-4 mb-4 border-b">
      <div class="w-1/4 text-left">
        Color
      </div>

      <div class="w-full flex">
        <div
          class="w-6 h-6 m-1 rounded flex items-center justify-center cursor-pointer"
          :class="color"
          :key="color"
          v-for="color in colors"
          @click="toggleColor(color)"
        >
          <i v-if="selectedColor === color" class="fas fa-check text-white"></i>
        </div>
      </div>
    </div> <!-- End of color picker -->

    <div v-if="canPickTextIcon" class="flex items-center py-4 mb-4 border-b">
      <div class="w-1/4 text-left">
        Icon color
      </div>

      <div class="w-full flex">
        <div
          class="w-6 h-6 m-1 rounded flex items-center justify-center cursor-pointer border border-color-black"
          :class="color_text === 'text-white' ? 'bg-white': 'bg-black'"
          :key="color_text+'text'"
          v-for="color_text in icon_text_color"
          @click="toggleTextColor(color_text)"
        >
          <i v-if="selectedTextColor === color_text" class="fas fa-check" :class="color_text === 'text-white' ? 'text-black': 'text-white'"></i>
        </div>
      </div>
    </div>

    <div class="flex items-start border-b mb-2" :class="canPickColor ? 'py-4' : 'pb-4'">
      <div class="w-1/4 text-left flex">
        Icon
      </div>

      <div class="w-full">
        <div class="mb-2">
          <input class="rounded border w-full p-2 outline-none" placeholder="Search for an icon" v-model="search" type="text">
        </div>

        <div class="w-full overflow-y-scroll" style="height: 200px">
          <div class="flex flex-wrap">
            <div
              class="w-10 h-10 m-2 rounded cursor-pointer tooltip-container relative"
              :class="selectedIcon === icon ? selectedColor : 'bg-grey'"
              :key="icon"
              v-for="icon in iconsFiltered"
              @click="selectIcon(icon)"
            >
              <!-- <i class="text-white fas fa-lg" :class="'fa-' + icon"></i> -->
              <icon :name="icon" class="text-white"></icon>
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs -mt-5 tooltip-msg pointer-events-none">
                <p class="text-black text-xs font-sans whitespace-no-wrap">{{ icon }}</p>
              </div>
            </div>
          </div> <!-- end of icon loop container -->
        </div>
      </div>
    </div> <!-- End of icon picker -->

    <div class="mb-2 text-right">
      <button @click="save" class="bg-tertiary text-white rounded px-4 py-3 uppercase text-sm font-medium align-bottom ml-auto mr-3">Save</button>
      <button @click="cancel" class="bg-grey text-white rounded px-4 py-3 uppercase text-sm font-medium align-bottom ml-auto">Close</button>
    </div>
  </div>
</template>

<script>
// import icons from '@/fontawesome-icon-map'
import icons from '@/members-icon-map'
import { EventBus } from '@/EventBus'

export default {
  props: {
    canPickColor: { default: true },
    canPickTextIcon: { default: false }
  },

  data () {
    return {
      search: '',
      selectedColor: 'bg-primary',
      selectedTextColor: 'text-white',
      selectedIcon: null,
      tooltip: false,
      colors: ['bg-primary', 'bg-secondary', 'bg-tertiary', 'bg-pl-red', 'bg-pl-aqua', 'bg-pl-purple', 'bg-pl-yellow', 'bg-pl-green', 'bg-pl-blue', 'bg-pl-dark-blue', 'bg-green', 'bg-red', 'bg-yellow', 'bg-blue', 'bg-purple', 'bg-red-custom'],
      icon_text_color: ['text-black', 'text-white']
    }
  },

  computed: {
    icons () {
      return icons
    },

    iconsFiltered () {
      if (this.search !== '') {
        return this.icons.filter(item => item.indexOf(this.search) !== -1)
      }

      return this.icons
    }
  },

  methods: {
    selectIcon (icon) {
      this.selectedIcon = icon
    },

    toggleColor (color) {
      if (this.selectedColor === color) {
        this.selectedColor = null
      } else {
        this.selectedColor = color
      }
    },

    toggleTextColor (color) {
      if (this.selectedTextColor === color) {
        this.selectedTextColor = null
      } else {
        this.selectedTextColor = color
      }
    },

    save () {
      EventBus.$emit('icon-picker:saved', {
        color: this.selectedColor,
        icon: this.selectedIcon,
        icon_text_color: this.selectedTextColor
      })
    },

    cancel () {
      EventBus.$emit('icon-picker:cancel')
    }
  }
}
</script>
